<template>
  <div class="table-wrapper cover-content project-list">
    <!-- <high-search>  -->
    <Form
      ref="formInline"
      :model="formInline"
      inline
      class="form-list"
      :label-width="100"
      label-position="right"
    >
      <Row :gutter="16">
        <Col span="6">
          <FormItem label="项目名称:" prop="projectName">
            <Input
              v-model="formInline.projectName"
              placeholder="请输入项目名称"
            ></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="项目所在地:">
            <place-select v-model="formInline.areaCode"></place-select>
            <!--<Select v-model="areaCode">-->
            <!--<Option v-for="item in area" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
            <!--</Select>-->
          </FormItem>
        </Col>

        <Col span="8">
          <FormItem label="供应商名称:" prop="supplierName">
            <Input
              v-model="formInline.supplierName"
              placeholder="请输入供应商名称"
            ></Input>
          </FormItem>
        </Col>
        <Col span="4" class="high-search">
          <Button type="primary" @click="handleQuery">搜索</Button>
          <Button style="margin-left: 20px" @click="handleReset">重置</Button>
          <span
            :class="open ? 'search-open' : 'search-close'"
            @click="open = !open"
            >{{ open ? "收起" : "展开" }}
            <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'"
          /></span>
        </Col>
      </Row>
      <Row :gutter="16" v-show="open">
        <Col span="6">
          <FormItem label="项目状态:" prop="prjStatus">
            <Select
              v-model="formInline.prjStatus"
              clearable
              placeholder="请选择项目状态"
            >
              <Option
                v-for="(item, index) in projectStatus"
                :value="item.code"
                :key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="项目分类：" prop="category">
            <Select
              v-model="formInline.category"
              clearable
              placeholder="请选择项目分类"
            >
              <Option
                v-for="(item, index) in projectCatetory"
                :value="item.code"
                :key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="实名制情况:" prop="regState">
            <RadioGroup v-model="formInline.regState">
              <Radio :label="-1">全部</Radio>
              <Radio :label="1">已上传实名数据</Radio>
              <Radio :label="0">未上传实名数据</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <!-- <Col span="6">
           <FormItem label="实名制情况:" prop="regState">
            <RadioGroup v-model="formInline.regState">
              <Radio :label="-1">全部</Radio>
              <Radio :label="1">已上传实名数据</Radio>
              <Radio :label="0">未上传实名数据</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="开工时间：" prop="WorkTime">
            <DatePicker
              type="daterange"
              split-panels
              placeholder="请选择开始结束时间"
              :value="formInline.WorkTime"
              @on-change="formInline.WorkTime = $event"
              transfer
            ></DatePicker>
          </FormItem>
        </Col> -->
      </Row>
      <Row :gutter="16" v-show="open">
        <Col span="6">
          <FormItem label="施工许可证办理情况：" prop="buildNumFlag">
            <Select
              v-model="formInline.buildNumFlag"
              clearable
              placeholder="请选择施工许可证办理情况"
            >
              <Option :value="0">全部</Option>
              <Option :value="1">已办理施工许可证</Option>
              <Option :value="2">正在办理施工许可证</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="开工报告办理情况：" prop="startReportFlag">
            <Select
              v-model="formInline.startReportFlag"
              clearable
              placeholder="请选择项目分类"
            >
              <Option :value="0">全部</Option>
              <Option :value="1">已办理开工报告</Option>
              <Option :value="2">正在办理开工报告</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="推送状态:" prop="pushStatus">
            <RadioGroup v-model="formInline.pushStatus">
              <Radio :label="''">全部</Radio>
              <Radio :label="1">启用推送</Radio>
              <Radio :label="0">停止推送</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="6">
          <!-- <Button type="primary" icon="ios-exit-outline" @click="pushStatus(pushArr, '1')">导出</Button> -->
          <Button
            type="primary"
            @click="pushStatus(pushArr, '1')"
     
            :disabled="disabledTitle"
            >批量启动推送</Button
          >
          <Button
            type="primary"
            @click="pushStatus(pushArr, '0')"
            style="margin-left: 20px"
            :disabled="disabledTitle"
            >批量停止推送</Button
          >
        </Col>
            <Col span="6">
          <FormItem label="选择配置的接口：" prop="buildNumFlag">
            <Select
              v-model="formInline.pushModel"
              clearable
              placeholder="请选配置的接口"
              @on-change="changeSelect"
            >
              <Option  :value="item.id" v-for="(item, index) in pushList" :key="index">{{item.systemName}}</Option>
             
            </Select>
          </FormItem>
        </Col>
        <Col span="8" v-show="open">
          <FormItem label="项目信息推送结果:" prop="pushResult">
            <RadioGroup v-model="formInline.pushResult">
              <Radio :label="''">全部</Radio>
              <Radio :label="'0'">推送成功</Radio>
              <Radio :label="'1'">推送失败</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <!-- </high-search> -->
    <Table
      style="margin-top:10px;"
      border
      :loading="loading"
      :columns="tableColumns"
      :data="tableData"
      highlight-row
      @on-selection-change="selected"
    >
      <template slot-scope="{ row, index }" slot="action">
        <span
          class="pointer"
          @click="handleDeal('projectDetail', row.projectId,row.projectName)"
          >项目详情</span
        >
        <span
          class="pointer"
          style="margin-left:8px;"
          @click="handleDeal('dataPushDetails', row.projectId, row.projectName)"
          >推送详情</span
        >
        <span
          class="pointer"
          style="margin-left:8px;"
          @click="handleDeal('dataPushKey', row.projectId, row.projectName)"
          v-if="formInline.pushModel == '5'"
          >密钥管理</span
        >
        <span
            class="pointer"
            style="margin-left:8px;"
            @click="handleDeal('editProjectGdm', row.projectId, row.projectName)"
            v-if="formInline.pushModel == '6'"
        >编辑</span
        >
        <!-- <span
          v-if="row.pushStatus === '推送中'"
          class="pointer"
          @click="pushState(row.projectId, '0')"
          >停止推送</span
        >
        <span
          v-if="row.pushStatus === '停止推送'"
          class="pointer"
          @click="pushState(row.projectId, '1')"
          >启用推送</span
        > -->
      </template>
    </Table>
    <div class="page">
      <Page
        :total="totalCount"
        :page-size="pageSize"
        :current="page"
        @on-change="changePage"
        @on-page-size-change="pageSizeChange"
        show-elevator
        show-sizer
        show-total
        transfer
      >
      </Page>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <span>正在推送中,到推送详情中查看结果.......</span>
      <span slot="footer" class="dialog-footer">
        <!-- <Button @click="centerDialogVisible = false">取 消</Button> -->
        <Button
          type="primary"
          @click="centerDialogVisible = false"
          style="margin-left:20px;"
          >确 定</Button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import tableMixin from "@/components/tableMixin";
export default {
  mixins: [tableMixin],
  data() {
    return {
      //推送系统列表
      pushList:[],
      //弹窗
      centerDialogVisible: false,
    //推送选择的id数组
      pushArr:[],
      open: false,
      formInline: {
        pushStatus: "",
        areaCode: localStorage.getItem("tenantAreaCode"),
        //项目名称：
        projectName: "",
        //项目分类：
        category: "",

        //项目状态：
        prjStatus: "",
        //实名制状态：
        regState: "",
        //施工许可证办理情况 0全部1已办理2正在办理
        buildNumFlag: 0,
        //供应商名称
        supplierName: "",
        // 推送
        // pushStatus: "",
        startReportFlag: 0,
        //推送系统
        pushModel:'',
        pushResult: '',
      },
      disabledTitle: true,
      tableColumns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: "left",
        },
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
          fixed: "left",
        },
        {
          title: "项目名称",
          key: "projectName",
          minWidth: 120,
          tooltip: true,
          align: "left"
        },
        {
          title: "项目所在地",
          key: "areaName",
          minWidth: 120,
          tooltip: true,
          align: "left"
        },
        {
          title: "项目供应商名称",
          key: "supplierName",
          minWidth: 150,
          tooltip: true,
          align: "left"
        },
        {
          title: "项目状态",
          key: "prjStatus",
          minWidth: 100,
          tooltip: true,
          align: "left"
        },
        {
          title: "项目分类",
          key: "category",
          minWidth: 100,
          tooltip: true,
          align: "left"
        },
        {
          title: "实名制情况",
          key: "regState",
          minWidth: 120,
          tooltip: true,
          align: "left"
        },
        {
          title: "施工许可证情况",
          key: "buildNumStatus",
          minWidth: 140,
          tooltip: true,
          align: "left"
        },

        // {
        //   title: "供应商名称",
        //   key: "supplierName",
        //   minWidth: 100,
        //   tooltip: true,
        // },
        {
          renderHeader: (h) => {
                  return h('div', [
                      h('div', '推送状态'),
                  ]);
              },
          key: "pushStatus",
          minWidth: 150,
          tooltip: true,
          align: "left"
        },
        {
              renderHeader: (h) => {
                  return h('div', [
                      h('div', '项目信息推送结果'),
                  ]);
              },
              key: "pushResult",
              minWidth: 150,
              tooltip: true,
          },
          {
              renderHeader: (h) => {
                  return h('div', [
                      h('div', '考勤信息推送结果'),
                  ]);
              },
              key: "attendanceResult",
              minWidth: 150,
              tooltip: true,
          },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 230,
          fixed: "right",
        },
      ],
      tableData: [],
      exportData: {},
    };
  },
  computed: {
    ...mapState(["area"]),
    ...mapGetters(["projectStatus", "projectCatetory"]),
  },
  created() {
    this.$route.query.areaCode &&
      (this.formInline.areaCode = this.$route.query.areaCode);
    this.formInline.regState = this.$route.query.regState
      ? this.$route.query.regState
      : -1;
    this.formInline.prjStatus = this.$route.query.prjStatus
      ? this.$route.query.prjStatus
      : "";
      this.getPushList();
  },
  mounted() {},
  watch: {},
  methods: {
    /*处理操作*/
    handleDelete(projectId) {
      this.$Modal.confirm({
        title: "提示",
        content: `确定要删除该项吗？`,
        onOk: () => {
          this.axios({
            method: "delete",
            url: `/project/delete/${projectId}`,
            data: {},
          }).then((res) => {
            if (res.data.success) {
              this.$Message.success({
                content: "操作成功",
              });
              this.getTableData();
            } else {
              this.$Message.warning({
                content: "操作失败",
              });
            }
          });
        },
        onCancel: () => {},
      });
    },
    handleReset() {
      this.formInline = {
        areaCode: localStorage.getItem("tenantAreaCode"),
        //项目名称：
        projectName: "",
        //项目分类：
        category: "",
        //施工单位：
        winUnit: "",
        //建设单位：
        buildCorpName: "",
        //项目状态：
        prjStatus: "",
        //开工开始时间:
        startWorkTimeStart: "",
        //开工结束时间：
        startWorkTimeEnd: "",
        //实名制状态：
        regState: -1,
        WorkTime: [],
        //施工许可证办理情况 0全部1已办理2正在办理
        buildNumFlag: 0,
        startReportFlag: 0,
        pushResult:''
   
      };
      this.getTableData();
    },
    //导出
    handleExport() {
      let param = {
        size: this.pageSize,
        current: this.page,
      };
      this.formInline.startWorkTimeStart = this.formInline.WorkTime[0];
      this.formInline.startWorkTimeEnd = this.formInline.WorkTime[1];
      Object.assign(param, this.formInline);
      delete param.WorkTime;
      this.axios({
        method: "post",
        url: "/project/export",
        responseType: "arraybuffer",
        data: param,
      }).then((response) => {
        this.common.download(
          response,
          "项目数据.xls",
          "application/vnd.ms-excel"
        );
      });
    },
    /*处理操作*/
    handleDeal(name, projectId, projectName) {
      if (name == 'dataPushKey' && this.formInline.pushModel == '') {
        this.open = true
        this.$Message.warning('请先选择配置的接口！')
        return
      }
      this.$router.push({
        name: name,
        query: {
          projectId: projectId,
          projectName: projectName,
          systemId: this.formInline.pushModel
        },
      });
    },
    //推送接口
    selected(val) {
      this.pushArr = val.map((item) => item.projectId);
      if (this.pushArr.length > 0 && this.formInline.pushModel !== '') {
        this.disabledTitle = false;
      }
    },
    changeSelect(val){
      if (this.pushArr.length > 0 && val !== '') {
        this.disabledTitle = false;
      }
    },
    pushStatus(arr, status) {
      this.centerDialogVisible = true;
      let arrStr = arr.join(",");
      this.loading = false;
      this.axios({
        method: "get",
        url: "/push/projectAllInfo",
        params: {
          projectId: arrStr,
          pushStatus: status,
          systemId:this.formInline.pushModel
        },
      }).then((response) => {
        this.loading = false;
        console.log(333, response.data.success);
        if (response.data.success) {
          this.getTableData();
        }
      });
    },
    // 获取系统列表
    getPushList(){
      this.axios({
        method:'get',
        url:'/push/pushSystemInfo'
      }).then((res)=>{
        this.pushList = res.data.data;
        console.log("pushlist",this.pushList)
      })
    },
    /*获取表格数据*/
    getTableData() {
      let param = {
        size: this.pageSize,
        current: this.page,
      };
      // this.formInline.startWorkTimeStart = this.formInline.WorkTime[0];
      // this.formInline.startWorkTimeEnd = this.formInline.WorkTime[1];
      Object.assign(param, this.formInline);
      // delete param.WorkTime;
      this.exportData = param;
      this.loading = true;
      this.axios({
        method: "post",
        url: "/project/pageList",
        data: param,
      })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            this.totalCount = response.data.data.total;
            this.tableData = response.data.data.records;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
